import { validateOtp } from './validateOtp';
import { requestOtp } from './requestOtp';

export interface IOTP {
  validateOtp: typeof validateOtp;
  requestOtp: typeof requestOtp;
}

/**
 * @namespace
 */
const OTP: IOTP = {
  validateOtp,
  requestOtp,
};

export default OTP;
